module.exports = __webpack_public_path__ + "components/forecast-table/static/weather-forecast_sunset-8183a119e59d0d0b9c975df068397e32.svg";